export default "__VITE_ASSET__Q2QnDZlb__"